import {OverlayTrigger} from '_core'

import {FC, useState} from 'react'
import {Popover} from 'react-bootstrap'
import MessageDialog from '../../components/ShippingComplianceMessage/MessageDialog'

type Props = {
  message: string
  popupMessage: string
  title?: string
  status: any
}

const MessagePopoverWithPopup: FC<Props> = ({message, status, title, popupMessage}) => {
  const [popup, setPopup] = useState(false)
  const handlePopup = () => {
    setPopup(!popup)
  }

  if (!message) {
    return null
  }

  const popover = (
    <Popover id='popover-basic'>
      {title && <Popover.Header as='h3'>{title}</Popover.Header>}
      <Popover.Body>
        <span className='text-muted'>{message}</span>
      </Popover.Body>
    </Popover>
  )

  return (
    <>
      <OverlayTrigger trigger={['hover', 'focus']} placement='top' overlay={popover}>
        <span onClick={handlePopup} className='cursor-pointer'>
          {status}
        </span>
      </OverlayTrigger>
      <MessageDialog message={popupMessage} title='Compliance' show={popup} onClose={handlePopup} />
    </>
  )
}

export default MessagePopoverWithPopup
